import * as Sentry from "@sentry/react";

if (import.meta.env.VITE_SENTRY_ENV) {
    Sentry.init({
      dsn: "https://b9635b17222bc2870a2dd33d6b75895d@sentry.hep.solutions//7",
      sendDefaultPii: true,
      environment: import.meta.env.VITE_SENTRY_ENV,
      integrations: [
        Sentry.browserTracingIntegration(),
      ],
      enableLogs: true,
      tracesSampleRate: 1,  
    });
}
